// Mock data for Foco Vision landing page (frontend-only teaser)

export const clinic = {
  name: "Foco Vision",
  tagline: "Centro Oftalmológico",
  phone: "+55 83 98186-9640",
  phoneDigits: "5583981869640",
  instagram: "focovision_",
  instagramUrl: "https://instagram.com/focovision_",
  whatsappText: "Ol\u00e1, acessei o site da Foco Vision e gostaria de agendar uma consulta.",
  address: {
    building: "Eco Business Center",
    street: "Antonio Rabelo J\u00fanior, N\u00b0 161",
    room: "Sala 112",
    district: "Miramar",
    city: "Jo\u00e3o Pessoa",
    state: "PB",
    cep: "58032-090",
  },
};

export const whatsappLink = `https://api.whatsapp.com/send?phone=${clinic.phoneDigits}&text=${encodeURIComponent(clinic.whatsappText)}`;

export const mapsLink =
  "https://www.google.com/maps/search/?api=1&query=Eco+Business+Center+Antonio+Rabelo+Junior+161+Miramar+Joao+Pessoa+PB";

export const navLinks = [
  { label: "In\u00edcio", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Tratamentos", href: "#tratamentos" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Clínica", href: "#clinica" },
  { label: "Blog", href: "#blog" },
  { label: "Contato", href: "#contato" },
];

export const hero = {
  eyebrow: "Sa\u00fade ocular de exce\u00eal\u00eancia",
  title: "Cuidado especializado para a sua vis\u00e3o",
  subtitle:
    "Na Foco Vision unimos tecnologia de ponta e atendimento humanizado para diagn\u00f3stico, tratamento e preven\u00e7\u00e3o das doen\u00e7as da retina, v\u00edtreo e da vis\u00e3o em geral.",
  image:
    "https://images.unsplash.com/photo-1722419136179-991a684eee53?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  stats: [
    { value: "+15", label: "anos de experi\u00eancia" },
    { value: "+20mil", label: "pacientes atendidos" },
    { value: "98%", label: "satisfa\u00e7\u00e3o dos pacientes" },
  ],
};

export const about = {
  eyebrow: "Quem Somos",
  title: "Um novo conceito em sa\u00fade ocular",
  paragraphs: [
    "A Foco Vision \u00e9 um centro oftalmol\u00f3gico especializado no cuidado completo da vis\u00e3o, com foco no tratamento das doen\u00e7as da retina e do v\u00edtreo.",
    "Nossa equipe emprega recursos avan\u00e7ados que garantem um atendimento humanizado e personalizado, com a agilidade que cada condi\u00e7\u00e3o necessita.",
    "Atendemos consultas, exames e procedimentos com estrutura moderna no cora\u00e7\u00e3o de Jo\u00e3o Pessoa.",
  ],
  image:
    "https://images.pexels.com/photos/33857823/pexels-photo-33857823.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=940",
  bullets: [
    "Atendimento particular e por reembolso",
    "Equipamentos de diagn\u00f3stico de \u00faltima gera\u00e7\u00e3o",
    "Equipe especializada em retina e v\u00edtreo",
  ],
};

export const treatments = [
  {
    id: "catarata",
    title: "Cirurgia de Catarata",
    short: "Substitui\u00e7\u00e3o do cristalino opaco por lente intraocular.",
    image:
      "https://images.unsplash.com/photo-1677773382668-8a84321836e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    description:
      "A catarata \u00e9 caracterizada pela perda da transpar\u00eancia do cristalino, respons\u00e1vel pelo foco da vis\u00e3o. A cirurgia remove o cristalino opaco e o substitui por uma lente intraocular, restaurando a nitidez visual com um procedimento r\u00e1pido e seguro.",
  },
  {
    id: "refrativa",
    title: "Cirurgia Refrativa",
    short: "Corre\u00e7\u00e3o de miopia, hipermetropia e astigmatismo a laser.",
    image:
      "https://images.unsplash.com/photo-1539036776273-021ec1d78bec?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    description:
      "Procedimento seguro e eficaz que utiliza tecnologia a laser de \u00faltima gera\u00e7\u00e3o para corre\u00e7\u00e3o de miopia, hipermetropia e astigmatismo, reduzindo ou eliminando a depend\u00eancia de \u00f3culos e lentes de contato.",
  },
  {
    id: "intravitrea",
    title: "Inje\u00e7\u00e3o Intrav\u00edtrea",
    short: "Aplica\u00e7\u00e3o de medicamento diretamente no olho.",
    image:
      "https://images.unsplash.com/photo-1627502208346-b835b72c0f05?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    description:
      "Modalidade de tratamento na qual o medicamento \u00e9 aplicado dentro do olho para tratar doen\u00e7as como degenera\u00e7\u00e3o macular e retinopatia diab\u00e9tica. \u00c9 um procedimento ambulatorial r\u00e1pido e realizado com o m\u00e1ximo de seguran\u00e7a.",
  },
  {
    id: "vitrectomia",
    title: "Vitrectomia Posterior",
    short: "Remo\u00e7\u00e3o do v\u00edtreo para tratar doen\u00e7as da retina.",
    image:
      "https://images.pexels.com/photos/5965843/pexels-photo-5965843.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Procedimento cir\u00fargico no qual o v\u00edtreo \u00e9 removido com o objetivo de tratar doen\u00e7as relacionadas \u00e0 retina, como descolamento de retina, hemorragias e membranas epirretinianas.",
  },
  {
    id: "retinopexia",
    title: "Retinopexia",
    short: "Reparo do descolamento de retina.",
    image:
      "https://images.pexels.com/photos/34093141/pexels-photo-34093141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "T\u00e9cnica para reparar o descolamento de retina, podendo ser realizada de forma isolada ou associada \u00e0 vitrectomia. Nas modalidades minimamente invasivas, est\u00e1 associada \u00e0 recupera\u00e7\u00e3o mais r\u00e1pida.",
  },
  {
    id: "laser",
    title: "Laser de Retina",
    short: "Fotocoagula\u00e7\u00e3o a laser no consult\u00f3rio.",
    image:
      "https://images.pexels.com/photos/5996649/pexels-photo-5996649.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "A fotocoagula\u00e7\u00e3o a laser \u00e9 realizada de forma rotineira no consult\u00f3rio para tratar doen\u00e7as vasculares que envolvem o fundo do olho, prevenindo a progress\u00e3o de les\u00f5es na retina.",
  },
];

export const differentials = [
  {
    icon: "Clock",
    title: "Agilidade no atendimento",
    text: "Estrutura preparada para atender com rapidez as condi\u00e7\u00f5es que exigem urg\u00eancia.",
  },
  {
    icon: "Microscope",
    title: "Tecnologia avan\u00e7ada",
    text: "Equipamentos modernos para diagn\u00f3stico e tratamento com m\u00e1xima seguran\u00e7a.",
  },
  {
    icon: "HeartHandshake",
    title: "Atendimento humanizado",
    text: "Cuidado personalizado, colocando o paciente sempre no centro de tudo.",
  },
  {
    icon: "Award",
    title: "Equipe qualificada",
    text: "Profissionais especializados em retina e v\u00edtreo, prontos para cada desafio.",
  },
];

export const gallery = [
  "https://images.unsplash.com/photo-1494869042583-f6c911f04b4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/34093126/pexels-photo-34093126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/5752284/pexels-photo-5752284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/34093126/pexels-photo-34093126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1483519173755-be893fab1f46?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/5965843/pexels-photo-5965843.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const blogPosts = [
  {
    id: "descolamento-retina",
    category: "Retina",
    readTime: "Leitura de 5 min",
    title: "Descolamento de retina: sinais de alerta",
    excerpt:
      "Flashes de luz, moscas volantes e uma cortina escura no campo visual podem indicar descolamento de retina. Entenda quando procurar ajuda.",
    image:
      "https://images.pexels.com/photos/5996649/pexels-photo-5996649.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "controle-glicemico",
    category: "Preven\u00e7\u00e3o",
    readTime: "Leitura de 4 min",
    title: "Controle glic\u00eamico e a sa\u00fade dos olhos",
    excerpt:
      "Manter os n\u00edveis de a\u00e7\u00facar equilibrados \u00e9 essencial para prevenir a retinopatia diab\u00e9tica e preservar a vis\u00e3o.",
    image:
      "https://images.unsplash.com/photo-1483519173755-be893fab1f46?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    id: "catarata-lentes",
    category: "Catarata",
    readTime: "Leitura de 6 min",
    title: "Qual a melhor lente para cirurgia de catarata?",
    excerpt:
      "Existem diferentes tipos de lentes intraoculares. Saiba como escolher a op\u00e7\u00e3o ideal para o seu estilo de vida.",
    image:
      "https://images.pexels.com/photos/34093141/pexels-photo-34093141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];
